import React, { useEffect, useState } from "react";
import {
  Table,
  Modal,
  Select,
  DatePicker,
  Button,
  Typography,
  Space,
  Row,
  Col,
  Menu,
  Dropdown,
  message,
  Checkbox,
} from "antd";

import {
  CheckSquareOutlined,
  CloseSquareOutlined,
  DownOutlined,
  ExportOutlined,
  LeftOutlined,
  MoreOutlined,
  PrinterOutlined,
  RightOutlined,
} from "@ant-design/icons";
import moment from "moment";
import "../Pages/CSS/Traitement.css";
import { TraitementService } from "../Services/TraitementService";
import { InterroComptaService } from "../Services/InterroComptaService";
import dayjs from "dayjs";
import * as XLSX from "xlsx";
import { printFournComptService, printFournSoinsComptService } from "../Services/PrintFournSoinsComptService";
const { RangePicker } = DatePicker;
const { Option } = Select;
const { Text } = Typography;
const getSelectedYear = () => {
  const currentYear = new Date().getFullYear();
  return currentYear.toString();
};
const FournComptSoins = () => {
  const [selectedYear, setSelectedYear] = useState(null);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [exercices, setExercices] = useState([]);
  const [societes, setSocietes] = useState([]);
  const [refetch, setRefetch] = useState(null);
  const [dateDeb, setDateDeb] = useState(null);
  const [dateFin, setDateFin] = useState(null);
  const [selectEcriture, setSelectEcriture] = useState("ALL");
  const [selectedSociete, setSelectedSociete] = useState("400000");
  const [adherents, setAdherents] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [totalDebit, setTotalDebit] = useState(0);
  const [totalCredit, setTotalCredit] = useState(0);
  const [totalSolde, setTotalSolde] = useState(0);
  const [soldeSelection, setSoldeSelection] = useState(0);
  const [selectedAdherent, setSelectedAdherent] = useState(null);
  const [anomaliesData, setAnomaliesData] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const traitementFactureService = new TraitementService();
  const interroService = new InterroComptaService();

  useEffect(() => {
    const fetchSocietes = async () => {
      try {
        const societesData = await interroService.getAllFournSoinCompt();
        setSocietes(societesData);
      } catch (error) {
        console.error("Erreur lors de la récupération des sociétés :", error);
      }
    };

    const fetchExercices = async () => {
      try {
        const data = await traitementFactureService.getExercices();
        setExercices([...data].sort((a, b) => b - a));
      } catch (error) {
        console.error("Erreur lors de la récupération des exercices :", error);
      }
    };
    const fetchDefaultDates = async () => {
      try {
        // const paramData = await traitementFactureService.getParamComptable();
        const paramData = await traitementFactureService.getParamComptable();
        const yearFromParamData = dayjs(paramData.datedeb).format("YYYY");
        setSelectedYear(yearFromParamData)
      } catch (error) {
        console.error(
          "Erreur lors de la récupération des dates par défaut :",
          error
        );
      }
    };

    fetchDefaultDates();
    fetchSocietes();
    fetchExercices();
  }, []);

  useEffect(() => {
    if (selectedYear) {
      setDateDeb(new Date(parseInt(selectedYear), 0, 1));
      setDateFin(new Date(parseInt(selectedYear), 11, 31));
    }
  }, [selectedYear]);

  useEffect(() => {
    const fetchAdherents = async () => {
      try {
        const adherentsData = await interroService.getadherentFourn(
          selectedSociete
        );
        setAdherents(adherentsData);
        if (adherentsData.length > 0) {
          setSelectedAdherent(adherentsData[0].comptetiers);
        } else {
          setSelectedAdherent(null);
        }
      } catch (error) {
        console.error("Erreur lors de la récupération des adhérents :", error);
        message.error(
          "Une erreur est survenue lors de la récupération des adhérents."
        );
      }
    };

    fetchAdherents();
  }, [selectedSociete]); // Ce useEffect se déclenchera à chaque changement de selectedSociete

  const handleSocieteChange = async (value) => {
    setSelectedSociete(value);
  };

  useEffect(() => {
    if (!selectedAdherent) return;
    const fetchListAllParticipant = async () => {
      try {
        const participData = await interroService.getAllListFournisDivCompt(
          selectedAdherent,
          dateDeb,
          dateFin
        );
        setTableData(participData);
      } catch (error) {
        console.error(
          "Erreur lors de la récupération des participants :",
          error
        );
      }
    };

    fetchListAllParticipant();
  }, [refetch, selectedAdherent, dateDeb, dateFin]);

  const handleYearChange = (value) => {
    setSelectedYear(value);
    console.log(value);
    setDateDeb(new Date(value, 0, 1));
    setDateFin(new Date(value, 11, 31));
    setRefetch(Date.now());
    console.log(dateDeb);
  };

  const handlePrint = async () => {
    try {
      const formattedDateDeb = dayjs(dateDeb).format('YYYY-MM-DD');
      const formattedDateFin = dayjs(dateFin).format('YYYY-MM-DD');
      printFournSoinsComptService(selectedAdherent, selectedYear, formattedDateDeb, formattedDateFin); // déclenche l'impression

      message.success("Les documents sont en cours d'impression.");
    } catch (error) {
      console.error("Erreur lors de l'impression :", error);
      message.error("Une erreur est survenue lors de l'impression.");
    }
  };
  const handlePrintAll = async () => {

    try {
      const formattedDateDeb = dayjs(dateDeb).format('YYYY-MM-DD');
      const formattedDateFin = dayjs(dateFin).format('YYYY-MM-DD');
      printFournComptService(selectedSociete, selectedYear, formattedDateDeb, formattedDateFin); // déclenche l'impression

      message.success("Les documents sont en cours d'impression.");
    } catch (error) {
      console.error("Erreur lors de l'impression :", error);
      message.error("Une erreur est survenue lors de l'impression.");
    }
  };


  const onSelectChange = (selectedKeys) => {
    setSelectedRowKeys(selectedKeys);

  };
  const getSelectedSocieteIntitule = () => {
    const selected = societes.find((s) => s.compte === selectedSociete);
    return selected ? selected.intitule : "Aucune société sélectionnée";
  };



  const gestionMenu1 = (
    <Menu>
      <Menu.Item
        key="1"

        onClick={handlePrint}
      >
        Fournisseur Courant
      </Menu.Item>
      <Menu.Item
        key="2"

        onClick={handlePrintAll}
      >
        Tous les {getSelectedSocieteIntitule()}
      </Menu.Item>


    </Menu>
  );
  const allRowKeys = tableData
    .filter((data) => {
      if (selectEcriture === "Non") return data.lettrage === "Non";
      if (selectEcriture === "Oui") return data.lettrage === "Oui";
      return true;
    })
    .map((record) => record.numligne);

  const handleSelectAllChange = (e) => {
    setSelectedRowKeys(e.target.checked ? allRowKeys : []);
  };

  const rowSelection = {
    selectedRowKeys,
    columnTitle: (
      <Checkbox
        checked={allRowKeys.length > 0 && selectedRowKeys.length === allRowKeys.length}
        indeterminate={selectedRowKeys.length > 0 && selectedRowKeys.length < allRowKeys.length}
        onChange={handleSelectAllChange}
      />
    ),
    onChange: onSelectChange, // Utilisation de la fonction nommée

    selections: [
      {
        key: "select-all",
        text: (
          <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <CheckSquareOutlined style={{ color: "#52c41a" }} />
            Sélectionner toutes les lignes
          </span>
        ),
        onSelect: () => {
          const allKeys = tableData.map((item) => item.numligne);
          setSelectedRowKeys(allKeys);
          onSelectChange(allKeys); // Appel explicite pour inclure la logique de validation
        },
      },
      {
        key: "clear-selection",
        text: (
          <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <CloseSquareOutlined style={{ color: "#ff4d4f" }} />
            Désélectionner toutes les lignes
          </span>
        ),
        onSelect: () => {
          setSelectedRowKeys([]);
          onSelectChange([]); // Appel explicite avec un tableau vide
        },
      },
    ],

    getCheckboxProps: (record) => ({
      name: record.numligne,
    }),
  };
  const isButtonDisabled = selectedRowKeys.length === 0;

  /*   useEffect(() => {
      const newTotalDebit = tableData.reduce(
        (sum, record) => sum + (record.debit || 0),
        0
      );
      const newTotalCredit = tableData.reduce(
        (sum, record) => sum + (record.credit || 0),
        0
      );
      const newSoldes = newTotalDebit - newTotalCredit;
      setTotalSolde(newSoldes);
      setTotalDebit(newTotalDebit);
      setTotalCredit(newTotalCredit);
    }, [tableData]); */
  useEffect(() => {
    // Filtrer les données en fonction du type d'écriture sélectionné
    const filteredData = tableData.filter((data) => {
      if (selectEcriture === "Non") return data.lettrage === "Non";
      if (selectEcriture === "Oui") return data.lettrage === "Oui";
      return true; // 'ALL' sélectionné, pas de filtre
    });

    // Recalculer les totaux sur les données filtrées
    const newTotalDebit = filteredData.reduce(
      (sum, record) => sum + (parseFloat(record.debit) || 0),
      0
    );
    const newTotalCredit = filteredData.reduce(
      (sum, record) => sum + (parseFloat(record.credit) || 0),
      0
    );
    const newTotalSolde = newTotalDebit - newTotalCredit;

    setTotalDebit(newTotalDebit);
    setTotalCredit(newTotalCredit);
    setTotalSolde(newTotalSolde);
  }, [tableData, selectEcriture]); // Dépendances : recalcul à chaque fois que tableData ou selectEcriture change


  function formatNumber(number) {
    const num = Number(number);
    if (isNaN(num)) {
      return "0";
    }

    return new Intl.NumberFormat("fr-FR").format(num);
  }
  /* 
    const handleMenuClick = async (e) => {
      // Extraire les lignes sélectionnées du tableau de données complet
      const selectedRows = tableData.filter((row) =>
        selectedRowKeys.includes(row.numligne)
      );
      const totalDebit = selectedRows.reduce(
        (sum, record) => sum + (parseFloat(record.debit) || 0),
        0
      );
      const totalCredit = selectedRows.reduce(
        (sum, record) => sum + (parseFloat(record.credit) || 0),
        0
      ); */

  // Vérification de si la somme des débits et crédits est égale à zéro
  /*  if (totalDebit !== totalCredit) {
     message.warning("Le solde lettrage n'est pas égal à 0!");
     return;
   } */

  /*   try {
      const newLettrage = selectedRows.map((row) => ({
        ...row,
        lettrage: e.key,
      }));

      const response = await interroService.getLettrage(newLettrage);
      message.success("Lettrage effectué avec succès.");
      setRefetch(Date.now()); // Raffraîchir les données si nécessaire
    } catch (error) {
      message.error("Erreur lors du lettrage : " + error.message);
    }
  }; */

  const handleMenuClick = async (e) => {
    // Extraire les lignes sélectionnées du tableau de données complet
    const selectedRows = tableData.filter((row) =>
      selectedRowKeys.includes(row.numligne)
    );

    // Si l'utilisateur a sélectionné "Lettrer"
    if (e.key === "Oui") {
      const totalDebit = selectedRows.reduce(
        (sum, record) => sum + (parseFloat(record.debit) || 0),
        0
      );
      const totalCredit = selectedRows.reduce(
        (sum, record) => sum + (parseFloat(record.credit) || 0),
        0
      );

      // Vérification de si la somme des débits et crédits est égale à zéro
      if (totalDebit !== totalCredit) {
        message.warning("Le solde lettrage n'est pas égal à 0!");
        return;
      }
    }

    try {
      const newLettrage = selectedRows.map((row) => ({
        ...row,
        lettrage: e.key,
      }));

      const response = await interroService.getLettrage(newLettrage);
      message.success("Lettrage effectué avec succès.");
      setRefetch(Date.now()); // Raffraîchir les données si nécessaire
    } catch (error) {
      message.error("Erreur lors du lettrage : " + error.message);
    }
  };

  const handleLettrageAuto = async () => {
    try {
      if (!selectedAdherent) {
        message.warning("Veuillez sélectionner un fournisseur avant de continuer.");
        return;
      }

      if (tableData.length === 0) {
        message.warning("Aucune donnée disponible pour le lettrage.");
        return;
      }

      // Appel à l'API avec le contenu direct de tableData
      await interroService.lettrageFournActu(selectedAdherent, selectedYear);
      message.success("Lettrage automatique effectué avec succès.");

      // Forcer le rechargement des données après lettrage
      setRefetch(Date.now());
    } catch (error) {
      message.error("Erreur lors du lettrage automatique : " + error.message);
    }
  };

  const handleLettrageAll = async () => {
    try {
      if (!selectedAdherent) {
        message.warning("Veuillez sélectionner un fournisseur avant de continuer.");
        return;
      }

      if (tableData.length === 0) {
        message.warning("Aucune donnée disponible pour le lettrage.");
        return;
      }

      // Appel à l'API avec le contenu direct de tableData
      await interroService.lettrageFournAll(selectedYear);
      message.success("Lettrage automatique effectué avec succès.");

      // Forcer le rechargement des données après lettrage
      setRefetch(Date.now());
    } catch (error) {
      message.error("Erreur lors du lettrage automatique : " + error.message);
    }
  };


  const columns = [
    {
      title: "C.J.L",
      dataIndex: "codej",
      key: "codej",
      align: "center",
      sorter: (a, b) => {
        const valueA = a.codej || "";
        const valueB = b.codej || "";
        return valueA.localeCompare(valueB);
      },
    },
    {
      title: "Date Compta",
      dataIndex: "datecompta",
      key: "datecompta",
      align: "center",
      render: (text) => moment(text).format("DD MMM YYYY"),
      sorter: (a, b) => {
        const valueA = new Date(a.datecompta).getTime();
        const valueB = new Date(b.datecompta).getTime();
        return valueA - valueB;
      },
    },
    {
      title: "Mois trait.",
      dataIndex: "datetrait",
      key: "datetrait",
      align: "center",
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <div style={{ padding: 8 }}>
          <DatePicker
            picker="month"
            placeholder="Rechercher un mois"
            value={selectedKeys[0] ? dayjs(selectedKeys[0], "YYYY-MM") : null}
            format="MMM YYYY"
            disabledDate={(current) => current && current > dayjs().endOf('day')}
            onChange={(date) => {
              if (date) {
                setSelectedKeys([date.format("YYYY-MM")]);
              } else {
                setSelectedKeys([]);
              }
            }}
            style={{ marginBottom: 8, width: "100%" }}
          />
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Button
              onClick={() => {
                clearFilters();
                confirm();
              }}
              size="small"
              style={{ width: "48%" }}
            >
              Réinitialiser
            </Button>
            <Button
              type="primary"
              onClick={() => confirm()}
              size="small"
              style={{ width: "48%" }}
            >
              Rechercher
            </Button>
          </div>
        </div>
      ),
      onFilter: (value, record) => {
        const recordMonth = moment(record.datetrait).format("YYYY-MM");
        return recordMonth === value;
      },
      render: (text) => moment(text).format("MMM YYYY"),
      sorter: (a, b) => {
        const valueA = new Date(a.datetrait).getTime();
        const valueB = new Date(b.datetrait).getTime();
        return valueA - valueB;
      },
    },
    {
      title: "N° pièce",
      dataIndex: "numpiece",
      key: "numpiece",
      align: "center",
      sorter: (a, b) => {
        const valueA = a.numpiece || "";
        const valueB = b.numpiece || "";
        return valueA.localeCompare(valueB);
      },
    },
    {
      title: "N° Fact.",
      dataIndex: "numfactipm",
      key: "numfactipm",
      align: "center",
      sorter: (a, b) => {
        const valueA = a.numfactipm || "";
        const valueB = b.numfactipm || "";
        return valueA.localeCompare(valueB);
      },
    },
    {
      title: "Cpte. Gen.",
      dataIndex: "comptegen",
      key: "comptegen",
      align: "center",
      sorter: (a, b) => {
        const valueA = a.comptegen || "";
        const valueB = b.comptegen || "";
        return valueA.localeCompare(valueB);
      },
    },
    {
      title: "Cpte. Tiers",
      dataIndex: "comptetiers",
      key: "comptetiers",
      align: "center",
      sorter: (a, b) => {
        const valueA = a.comptetiers || "";
        const valueB = b.comptetiers || "";
        return valueA.localeCompare(valueB);
      },
    },
    {
      title: "Libellé",
      dataIndex: "libelle",
      key: "libelle",
      sorter: (a, b) => {
        const valueA = a.libelle || "";
        const valueB = b.libelle || "";
        return valueA.localeCompare(valueB);
      },
    },
    {
      title: "N° Chéque",
      dataIndex: "numcheque",
      key: "numcheque",
      sorter: (a, b) => {
        const valueA = a.numcheque || "";
        const valueB = b.numcheque || "";
        return valueA.localeCompare(valueB);
      },
    },
    {
      title: "Lettrage",
      dataIndex: "lettrage",
      key: "lettrage",
      align: "center",
      sorter: (a, b) => {
        const valueA = a.lettrage || "";
        const valueB = b.lettrage || "";
        return valueA.localeCompare(valueB);
      },
    },
    {
      title: (
        <div
          style={{
            backgroundColor: "#010f1c",
            color: "white",
            paddingRight: 10,
          }}
        >
          Débit
        </div>
      ),
      dataIndex: "debit",
      key: "debit",
      align: "right",
      render: (text) => (
        <div style={{ paddingRight: 10 }}>
          {text && parseFloat(text) !== 0 ? formatNumber(parseFloat(text)) : ""}
        </div>
      ),
      sorter: (a, b) => parseFloat(a.debit || 0) - parseFloat(b.debit || 0),
    },
    {
      title: (
        <div
          style={{
            backgroundColor: "#010f1c",
            color: "white",
            paddingRight: 10,
          }}
        >
          Crédit
        </div>
      ),
      dataIndex: "credit",
      key: "credit",
      align: "right",
      fixed: "right",
      render: (text) => (
        <div style={{ paddingRight: 10 }}>
          {text && parseFloat(text) !== 0 ? formatNumber(parseFloat(text)) : ""}
        </div>
      ),
      sorter: (a, b) => parseFloat(a.credit || 0) - parseFloat(b.credit || 0),
    },
  ];

  const onchangeEcriture = (value) => {
    setSelectEcriture(value); // Mettre à jour la sélection
    setRefetch(Date.now()); // Forcer le rechargement si nécessaire
  };

  // Fonction pour filtrer les données en fonction du lettrage
  const getFilteredData = () => {
    switch (selectEcriture) {
      case "Non":
        return tableData.filter((data) => data.lettrage);
      case "Oui":
        return tableData.filter((data) => !data.lettrage);
      case "ALL":
      default:
        return tableData;
    }
  };
  const lettrageMenu = (
    <Menu onClick={handleMenuClick}>
      <Menu.Item key="Oui">Lettrer</Menu.Item>
      <Menu.Item key="Non">Délettrer</Menu.Item>
    </Menu>
  );


  useEffect(() => {
    const selectedRows = tableData.filter((row) =>
      selectedRowKeys.includes(row.numligne)
    );
    const totalDebit = selectedRows.reduce(
      (sum, record) => sum + parseFloat(record.debit || 0),
      0
    );
    const totalCredit = selectedRows.reduce(
      (sum, record) => sum + parseFloat(record.credit || 0),
      0
    );

    const newSoldeSelection = totalDebit - totalCredit;
    setSoldeSelection(newSoldeSelection);
  }, [selectedRowKeys, tableData]); // Re-calcul à chaque changement de selectedRowKeys ou tableData

  const exportToExcel = (
    data,
    fileName = `compte ${selectedAdherent.comptetiers} ${selectedAdherent.participant}.xlsx`
  ) => {
    // Création d'un nouveau classeur
    const workbook = XLSX.utils.book_new();
    // Conversion des données en feuille de travail
    const worksheet = XLSX.utils.json_to_sheet(data);
    // Ajout de la feuille de travail au classeur
    XLSX.utils.book_append_sheet(workbook, worksheet, "Data");
    // Exportation du classeur (cela déclenchera le téléchargement)
    XLSX.writeFile(workbook, fileName);
  };

  const handlePreviousAdherent = () => {
    const currentIndex = adherents.findIndex(
      (adherent) => adherent.comptetiers === selectedAdherent
    );
    if (currentIndex > 0) {
      const previousAdherent = adherents[currentIndex - 1];
      setSelectedAdherent(previousAdherent.comptetiers);
    }
  };

  // Fonction pour gérer la navigation vers le fournisseur suivant
  const handleNextAdherent = () => {
    const currentIndex = adherents.findIndex(
      (adherent) => adherent.comptetiers === selectedAdherent
    );
    if (currentIndex < adherents.length - 1) {
      const nextAdherent = adherents[currentIndex + 1];
      setSelectedAdherent(nextAdherent.comptetiers);
    }
  };

  /**
   * Récupère les anomalies de lettrage pour l'année sélectionnée
   * et les stocke dans le state anomaliesLettrage.
   * @function
   */
  const handleAfficherAnomaliesLettrage = async () => {
    try {
      const data = await interroService.getAnomaliesLettrage(selectedYear);

      if (!data || data.length === 0) {
        message.info("Aucune anomalie détectée");
        return;
      }

      setAnomaliesData(data);
      setIsModalVisible(true);

    } catch (error) {
      console.error("Erreur lors de la récupération des anomalies:", error);
      message.error("Erreur lors de la récupération des anomalies");
    }
  };

  const handleVoirAnomalie = async (comptetiers) => {


    // Mettre à jour le fournisseur sélectionné
    setSelectedAdherent(comptetiers);

    // Réinitialiser le filtre d'écriture pour afficher toutes les écritures Lettrées
    setSelectEcriture("Oui");

    // Fermer le modal
    setIsModalVisible(false);

    // Forcer le rechargement des données pour ce fournisseur
    setRefetch(Date.now());

    message.info(`Affichage des données du fournisseur: ${comptetiers}`);
  };


  return (
    <div className="particip-compte-container">
      <Row gutter={16} style={{ marginBottom: "30px" }}>
        <Col>
          <Space direction="vertical" size="middle" style={{ display: "flex" }}>
            <Text>Spécialités</Text>
            <Select
              onChange={handleSocieteChange}
              defaultValue={selectedSociete}
              style={{ width: 350 }}
              showSearch
              filterOption={(input, option) =>
                option.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
            >
              {societes.map((societe) => (
                <Option key={societe.compte} value={societe.compte}>
                  {`${societe.compte} - ${societe.intitule}`}
                </Option>
              ))}
            </Select>
          </Space>
        </Col>
        <Col>
          <Space direction="vertical" size="middle" style={{ display: "flex" }}>
            <Text>Fournisseurs</Text>
            <Space>
              <Button
                className="Buttonvalid"
                icon={<LeftOutlined />}
                onClick={handlePreviousAdherent}
                disabled={adherents.findIndex(
                  (adherent) => adherent.comptetiers === selectedAdherent
                ) === 0} // Désactive le bouton si c'est le premier élément
              />
              <Select
                value={selectedAdherent}
                onChange={setSelectedAdherent}
                style={{ width: 350 }}
                showSearch
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
              >
                {adherents.map((adherent) => (
                  <Option key={adherent.comptetiers} value={adherent.comptetiers}>
                    {`${adherent.comptetiers} - ${adherent.fournisseur}`}
                  </Option>
                ))}
              </Select>
              <Button
                className="Buttonvalid"
                icon={<RightOutlined />}
                onClick={handleNextAdherent}
                disabled={adherents.findIndex(
                  (adherent) => adherent.comptetiers === selectedAdherent
                ) === adherents.length - 1} // Désactive le bouton si c'est le dernier élément
              />
            </Space>
          </Space>
        </Col>
      </Row>
      <Row
        gutter={16}
        justify="space-between"
        align="middle"
        style={{ marginBottom: "16px" }}
      >
        <Col
          style={{
            textAlign: "right",
            display: "flex",
            justifyContent: "start",
          }}
        >
          <Space>
            <Space direction="vertical" style={{ textAlign: "left" }}>
              <label>Exercice</label>
              <Select
                className="select-colored-accent"
                style={{
                  width: 90,
                  marginRight: 10,
                  "--select-accent": "#1890ff",
                  "--select-accent-bg": "#e6f4ff",
                  "--select-accent-shadow": "rgba(24, 144, 255, 0.25)",
                }}
                onChange={handleYearChange}
                value={selectedYear}
              >
                {exercices.map((year) => (
                  <Option key={year} value={year}>
                    {year}
                  </Option>
                ))}
              </Select>
            </Space>
            <Space direction="vertical" style={{ textAlign: "left" }}>
              <label>Période</label>
              {/*   <RangePicker
                format="DD/MM/YYYY"
                value={[dayjs(dateDeb), dayjs(dateFin)]}
              /> */}
              <RangePicker
                format="DD/MM/YYYY"
                value={[dayjs(dateDeb), dayjs(dateFin)]}
                onChange={(dates) => {
                  if (dates && dates.length === 2) {
                    setDateDeb(dates[0].toDate());
                    setDateFin(dates[1].toDate());
                    setRefetch(Date.now()); // Utiliser setRefetch pour forcer un rechargement des données
                  }
                }}
              />
            </Space>
            <Space direction="vertical" style={{ textAlign: "left" }}>
              <label style={{ marginBottom: "30px" }}>Type d'écriture</label>
              <Select
                className="select-colored-accent"
                style={{
                  width: 180,
                  marginRight: 10,
                  "--select-accent": "#722ed1",
                  "--select-accent-bg": "#f9f0ff",
                  "--select-accent-shadow": "rgba(114, 46, 209, 0.25)",
                }}
                defaultValue={selectEcriture}
                onChange={onchangeEcriture}
              >
                <Select.Option value="ALL">Toutes les écritures</Select.Option>
                <Option value="Non"> Écritures Non Léttrées</Option>
                <Option value="Oui"> Écritures Léttrées </Option>
              </Select>
            </Space>
          </Space>
        </Col>
        <Col
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginTop: "30px",
          }}
        >
          <Space>

            <Dropdown
              overlay={
                <Menu>
                  <Menu.Item
                    key="auto-current"
                    onClick={handleLettrageAuto}
                    disabled={!selectedAdherent || tableData.length === 0}
                  >
                    Fournisseur Actuel
                  </Menu.Item>
                  <Menu.Item
                    key="auto-all"
                    onClick={handleLettrageAll}
                    disabled={tableData.length === 0}
                  >
                    Tous les Fournisseurs
                  </Menu.Item>
                </Menu>
              }
            >
              <Button
                className="Buttonvalid"
                disabled={!selectedAdherent || tableData.length === 0}
              >
                Lettrage Auto <DownOutlined />
              </Button>
            </Dropdown>

            <Dropdown disabled={isButtonDisabled} overlay={lettrageMenu}>
              <Button>
                Lettrage Manuel <DownOutlined />
              </Button>
            </Dropdown>
            <Button
              onClick={() => exportToExcel(getFilteredData())}
              className="buttonExport"
              icon={<ExportOutlined />}
              disabled={tableData.length === 0}
            >
              Export Excel
            </Button>

            {/* <Button
              className="buttonImprim"
              icon={<PrinterOutlined />}
              onClick={handlePrint}
              disabled={tableData.length === 0} 
            >
              Imprimer Extrait
            </Button> */}
            <Dropdown
              disabled={tableData.length === 0}
              overlay={gestionMenu1}
              trigger={["click"]}
            >
              <Button className="buttonImprim" icon={<PrinterOutlined />}>
                Imprimer Extrait
                <MoreOutlined />
              </Button>
            </Dropdown>
          </Space>
        </Col>
      </Row>

      <Table
        scroll={{
          x: true,
        }}
        style={{ cursor: "pointer", whiteSpace: "nowrap", width: "100%" }}
        className="custom-header2-table my-custom-table"
        // permet aussi de maintenir la couleur de la ligne
        rowClassName={(record) =>
          selectedRowKeys.includes(record.numligne) ? "selected-row" : ""
        }
        pagination={{
          pageSizeOptions: ["5", "10", "20", "50", "100"], // Options disponibles pour la pagination
          showSizeChanger: true, // Permet à l'utilisateur de changer le nombre de lignes par page
          pageSize: pageSize, // Valeur actuelle du nombre de lignes par page
          onShowSizeChange: (current, size) => setPageSize(size), // Mise à jour de pageSize lors du changement
        }}
        bordered
        rowSelection={rowSelection}
        columns={columns}
        showSorterTooltip={false}
        rowKey="numligne"
        dataSource={tableData.filter((data) => {
          if (selectEcriture === "Non") return data.lettrage === "Non";
          if (selectEcriture === "Oui") return data.lettrage === "Oui";
          return true;
        })}
        title={() => (
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Space>
              <strong>Total Débit: {formatNumber(totalDebit)}</strong> -
              <strong>Total Crédit: {formatNumber(totalCredit)}</strong> -
              <strong style={{ color: "#4DBD74" }}>Soldes : {formatNumber(totalSolde)}</strong>
            </Space>


            <Space>
              <Button type="primary" size="small" onClick={handleAfficherAnomaliesLettrage}>
                Afficher Anomalies Lettrage
              </Button>
              <strong>Solde de la sélection:</strong>
              <b style={{ color: "#4DBD74" }}>
                {soldeSelection.toLocaleString()}
              </b>
            </Space>
          </div>
        )}
      />
      {
        isModalVisible && (
          <Modal
            title="Anomalies de Lettrage"
            visible={isModalVisible}
            onCancel={() => setIsModalVisible(false)}
            footer={[
              <Button key="fermer" onClick={() => setIsModalVisible(false)}>
                Fermer
              </Button>
            ]}
            width={800}
          >
            <Table
              dataSource={anomaliesData}
              pagination={{ pageSize: 10 }}
              scroll={{ y: 400 }}
            >
              <Table.Column
                title="Compte Tiers"
                dataIndex="comptetiers"
                key="comptetiers"
                align="center"
              />
              <Table.Column
                title="Fournisseur"
                dataIndex="fournisseur"
                key="fournisseur"
              />
              <Table.Column
                title="Solde"
                dataIndex="solde"
                key="solde"
                align="right"
                render={(text) => formatNumber(text)}
              />
              <Table.Column
                title="Action"
                key="action"
                align="center"
                render={(_, record) => (
                  <Button
                    type="primary"
                    size="small"
                    onClick={() => handleVoirAnomalie(record.comptetiers)}
                  >
                    Voir
                  </Button>
                )}
              />
            </Table>
          </Modal>
        )
      }
    </div>
  );
};

export default FournComptSoins;
